export enum ClientFormTypes {
    Name = 'name',
    PointOfContactEmail = 'email',
    PointOfContactFirstName = 'first_name',
    PointOfContactLastName = 'last_name',
}